import React, {Component} from 'react';

class ReferentenKreiseSelect extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        if (this.props.kreise.length === 0) {
            return <span>Bitte Regierungsbezirk wählen!</span>
        }
        return <div className={'form-group'}>
            <div><label>Kreisverband</label></div>
            <form onChange={this.onChange.bind(this)}>
            {
                this.props.kreise.map(
                    kreis => <div className={'form-check pull-left'} style={{paddingRight: '10px'}} key={kreis.name}>
                        <input type={'checkbox'} className={'form-check-input'} name={'kreisverband-'+this.props.selectedBezirk} value={kreis.name} />
                        <label className="form-check-label" htmlFor="exampleCheck1">{kreis.name}</label>
                        </div>
                )
            }
            </form>
            <div className={'clearfix'} />
        </div>
    }

    onChange(e){
        let el = e.target
        let name = el.name
        let stateChange = []

        let objType = Object.prototype.toString.call(el.form.elements[name])
        if (objType === '[object RadioNodeList]' || objType === '[object NodeList]' || objType === '[object HTMLCollection]') {
            let checkedBoxes = (Array.isArray(this.state[name]) ? this.state[name].slice() : [])
            if (el.checked) {
                checkedBoxes.push(el.value)
            } else {
                checkedBoxes.splice(checkedBoxes.indexOf(el.value), 1)
            }
            stateChange[name] = checkedBoxes
        } else {
            stateChange[name] = el.checked
        }

        this.setState(stateChange)
        this.props.selectKreis(stateChange[name].toString())
    }
}

export default ReferentenKreiseSelect


/*
return <div className={'form-group'}>
                <label>Kreisverband</label>
                <select className={'form-control custom-select'} value={this.props.selected} id={'kreisverband'} ref={'kreiseSelect'}
                        onChange={() => this.props.selectKreis(this.refs.kreiseSelect.value)}>
                    <option value={"null"}>Alle Landkreise</option>
                    {
                        this.props.kreise.map(
                            kreis => <option key={kreis.name} value={kreis.name}>{kreis.name}</option>
                        )
                    }
                </select>
        </div>
 */




// WEBPACK FOOTER //
// ./src/components/ReferentenKreiseSelect.js